/* eslint-disable */ 
import { isAndroid, isIos } from './utils';
import iosBridge from '@/plugins/ios-bridge';

const yj = {};

// 跳转页面
yj.jumpPage = (data) => {
  try {
    if (isAndroid()) {
      window.android.postData(JSON.stringify(data));
    }
    if (isIos()) {
      window.webkit.messageHandlers.YouJangAppAction.postMessage(JSON.stringify(data));
    }
  } catch (err) {
    console.log(err);
  }
};

// 发起分享（不弹分享到哪选择框）
yj.invokShare2 = (data) => {
  return new Promise((resolve, reject) => {
    try {
      if (isAndroid()) {
        console.log('android share');
        window.android.invokShare2(JSON.stringify(data));
      }
      if (isIos()) {
        iosBridge((bridge) => {
          // 调用iOS方法:
          bridge.callHandler('invokShare2', data, (response) => {
            console.log('JS got response', response);
            resolve(response);
          });
        });
      }
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
};

// 跳转至任务中心打开任务列表
yj.openTaskList = () => {
  try {
    if (isAndroid()) {
      window.android.openTaskList();
    }
    if (isIos()) {
      window.webkit.messageHandlers.openTaskList.postMessage({});
    }
  } catch (err) {
    console.log(err);
  }
};

// 跳转到我的奖品
yj.openMyPrize = () => {
  try {
    if (isAndroid()) {
      window.android.openMyPrize();
    }
    if (isIos()) {
      window.webkit.messageHandlers.openMyPrize.postMessage({});
    }
  } catch (err) {
    console.log(err);
  }
};

// 返回上一个页面
yj.goBack = () => {
  try {
    if (isAndroid()) {
      window.android.goBack();
    }
    if (isIos()) {
      window.webkit.messageHandlers.goBack.postMessage({});
    }
  } catch (err) {
    console.log(err);
  }
};

// 获取电池栏高度
yj.getStatusBarHeight = () => {
  return new Promise ((resolve, reject) => {
    try {
      if (isAndroid()) {
        console.log('android');
        const heightRes = window.android.getStatusBarHeight();
        resolve(heightRes);
        // resolve(44);
      }
      if (isIos()) {
        console.log('ios');
        iosBridge((bridge) => {
          /* Initialize your app here */
          // 注册函数,由iOS本地调用
          // bridge.registerHandler('testJavascriptHandler', function(data, responseCallback) {
          //   console.log('iOS called testJavascriptHandler with', data)
          //   responseCallback({ 'Javascript Says':'Right back atcha!' })
          // })
          // 调用iOS方法:
          bridge.callHandler('getStatusBarHeight', {}, (response) => {
            console.log('JS got response', response);
            resolve(response);
          });
        });
      }
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
};

export default yj;
